import React from "react";
import { Avatar, Box, Skeleton } from "@mui/material";

const TicketHeaderSkeleton = () => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      borderBottom: "1px solid",
      borderColor: "divider",
      bgcolor: "background.paper",
      flexShrink: 0,
    }}
  >
    {/* Row 1 */}
    <Box sx={{ display: "flex", alignItems: "center", pl: 0.5, pr: 1, minHeight: 56, gap: 1 }}>
      <Skeleton variant="circular" width={28} height={28} sx={{ flexShrink: 0 }} />
      <Skeleton animation="wave" variant="circular" sx={{ flexShrink: 0 }}>
        <Avatar sx={{ width: 38, height: 38 }} />
      </Skeleton>
      <Box sx={{ flex: 1 }}>
        <Skeleton animation="wave" width={140} height={18} />
        <Skeleton animation="wave" width={100} height={13} sx={{ mt: 0.5 }} />
      </Box>
    </Box>

    {/* Row 2 */}
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        px: 1.5,
        py: 0.75,
        gap: 1,
        borderTop: "1px solid",
        borderColor: "divider",
        minHeight: 44,
      }}
    >
      <Skeleton variant="rounded" width={90} height={24} sx={{ borderRadius: 1 }} />
      <Box sx={{ ml: "auto", display: "flex", gap: 0.75 }}>
        <Skeleton variant="rounded" width={50} height={22} sx={{ borderRadius: 2 }} />
        <Skeleton variant="rounded" width={80} height={28} sx={{ borderRadius: 1 }} />
        <Skeleton variant="rounded" width={90} height={28} sx={{ borderRadius: 1 }} />
      </Box>
    </Box>
  </Box>
);

export default TicketHeaderSkeleton;
